import React, { useEffect, useState } from "react";
import { FormControl, FormLabel, Input, IconButton, HStack, VStack, Textarea, RadioGroup, Radio, Box } from "@chakra-ui/react";
import { FiTrash } from "react-icons/fi";

const ListField: React.FC<any> = ({ field, value = [], readOnly, invalid }) => {
  const initialMode: 'na' | 'val' = value === 'N/A' ? 'na' : 'val';
  const [mode, setMode] = useState<'na' | 'val'>(initialMode);
  const [items, setItems] = useState<string[]>([]);

  useEffect(() => {
    setMode(value === 'N/A' ? 'na' : 'val');
    if (Array.isArray(value)) {
      setItems(value);
    } else if (typeof value === "string" && value !== "N/A") {
      setItems([value]);
    } else {
      setItems([]);
    }
  }, [value]);

  const handleAddItem = () => setItems(prev => [...prev, ""]);
  const handleRemoveItem = (index: number) => setItems(prev => prev.filter((_, i) => i !== index));
  const handleInputChange = (index: number, v: string) => setItems(prev => prev.map((it, i) => (i === index ? v : it)));

  const disabled = readOnly || mode === 'na';

  return (
    <FormControl mb={4} isInvalid={!!invalid} data-field-name={field?.name} className={invalid ? 'invalid' : ''}>
      <FormLabel>
        <b>{field.label}</b>
        {!field.nullable && <span style={{ color: "red" }}>*</span>}
      </FormLabel>

      <RadioGroup value={mode} onChange={n => !readOnly && setMode(n as 'na' | 'val')} isDisabled={readOnly}>
        {field.nullable === true && (
          <HStack mb={2}>
            <Radio value="na">TBD</Radio>
          </HStack>
        )}

        <HStack align="start" spacing={2}>
          {field.nullable === true && <Radio value="val" aria-label="Provide values" mt="6px" />}

          <Box flex="1" opacity={disabled ? 0.6 : 1} pointerEvents={disabled ? 'none' : 'auto'}>
            <VStack spacing={4} align="start">
              {items.map((item, index) => (
                <HStack key={index} spacing={2} width="100%" align="start">
                  <span>{index + 1}.</span>
                  {field.htmlType === "longText" ? (
                    <Textarea
                      name={field.name}
                      value={item}
                      onChange={(e) => handleInputChange(index, e.target.value)}
                      maxLength={field.limit}
                      isDisabled={disabled}
                      readOnly={readOnly}
                    />
                  ) : (
                    <Input
                      name={field.name}
                      type="text"
                      value={item}
                      onChange={(e) => handleInputChange(index, e.target.value)}
                      isDisabled={disabled}
                      readOnly={readOnly}
                      flex="1"
                    />
                  )}
                  {!readOnly && (
                    <IconButton
                      aria-label="Remove element"
                      icon={<FiTrash />}
                      onClick={() => handleRemoveItem(index)}
                      className="remove-element-btn"
                      isDisabled={disabled}
                    />
                  )}
                </HStack>
              ))}

              {!readOnly && (
                <HStack spacing={2} width="100%" align="center">
                  <button type="button" className="el-btn" onClick={handleAddItem} disabled={disabled}>
                    Add {field.singleLabel}
                  </button>
                </HStack>
              )}
            </VStack>
          </Box>
        </HStack>
      </RadioGroup>

      {mode === 'na' && <input type="hidden" name={field.name} value="N/A" />}
      {mode === 'val' && items.length === 0 && <input type="hidden" name={field.name} value="" />}
    </FormControl>
  );
};

export default ListField;
